/*******************************************************************************
 * Copyright (c) 2024 Belltane LLC
 *
 * All rights reserved.
 *
 * Contributors:
 *   Amina Rais - Initial implementation
 *
 * Version: 1.0.0
 *
 *******************************************************************************/

import React from 'react';
import Grid from '@mui/material/Grid';
 import { makeStyles } from 'tss-react/mui';

import Container from '@mui/material/Container';
import PageSubHeader from '../Layout/PageSubHeader'
import { useTranslation } from 'react-i18next';
import Aboutustext from '../shared/Aboutustext';
 
const About = () => {
  const { classes } = useStyles();
  const { t } = useTranslation()
  return (
    < >
      <PageSubHeader location={t('titles:aboutus')} />
      <Grid container spacing={4} className={classes.pageContainer}>
        <Grid item xs={12} sm={12} md={12}>
          <Container className={classes.cardGrid} maxWidth="xl">
            
            <Grid item xs={12} sm={12} md={12} className={classes.containerDotBG} style={{ padding: '20px' }}>
              <div data-aos='fade-up' data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="700">
                <Aboutustext />
              </div>
            </Grid>

          </Container>
        </Grid>
      </Grid>




    </ >
  );
}
const useStyles = makeStyles({ "name": { About } })((theme) => ({
 

  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    
  },
  sectionTitleBorder: {
    width: '100px',
    height: '2px',
    marginRight: 'auto',
    marginLeft: 'auto',
    backgroundColor: '#fb743e',
    marginBottom: '30px',
  },
  title: {
    paddingTop: '20px'
  }, containerDotBG: {
    backgroundColor: theme.palette.background.paper,
    backgroundPosition: '0 0, 50px 50px'
  },
}));

export  default About;
